import React, { useState, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import RenderInfo from './components/RenderInfo';
import { Heading } from '../../../../../components';
import Back from '@/presentation/reusables/Button/Back';
import { ContainerHeader, SubContainerCenter } from './style';
import ModalMessageFullCycle from './components/ModalMessageFullCycle';
import Processing from '@/presentation/components/Processing';
import { OptionType, getOptionsMessages } from './components/OptionsMessages';
import useBenefitActivation from '@/presentation/hooks/useActivationBenefitFullCycle';
import { Creators as pendingPaymentActions } from '@/domain/useCases/payments/getPendingPayments';
import { Creators as requestBenefitActions } from '@/domain/useCases/payments/getBenefitInstallments';
import { formatDiscountBenefitItems } from '@/presentation/modules/payments/modules/PayOnline/helpers';
import {
  ContainerProcedure,
  SubContainer
} from '@/presentation/modules/procedures/modules/certificates-constancies/type1/info/components/index';

interface IProps {
  dataDiscount: any;
  isLoading: boolean;
  handlerBack: () => void;
}

const FullCycleDiscountView = ({
  dataDiscount,
  isLoading,
  handlerBack
}: IProps) => {
  const dispatch = useDispatch();
  const [isDisabled, setIsDisabled] = useState(false);
  const [showModalUnavailable, setShowModalUnavailable] = useState(false);
  const [isLoadingDataDiscount, setIsLoadingDataDiscount] = useState(true);
  const [optionMessageView, setOptionMessageView] = useState<OptionType | null>(
    null
  );
  const {
    showModal: showModalActivate,
    optionMessage: optionMessageActivate,
    isLoadingProgress: isLoadingProgressActivate,
    toggleBenefit,
    resetModal
  } = useBenefitActivation();

  const { data: dataPending, isLoading: isLoadingPending } = useSelector(
    (state: any) => state.getPendingPayments
  );

  const { data: dataBenefit, isLoading: isLoadingBenefit } = useSelector(
    (state: any) => state.getBenefitInstallments
  );

  useEffect(() => {
    resetModal();
    setOptionMessageView(null);
    setShowModalUnavailable(false);
    dispatch(requestBenefitActions.getBenefitInstallmentsClear());
  }, []);

  // charge validatation initial
  useEffect(() => {
    setIsLoadingDataDiscount(isLoading);
    if (!dataDiscount || isLoading) return;

    const { validationError, totalAmount } = dataDiscount;
    setShowModalUnavailable(!!validationError);
    setIsDisabled(!!validationError);

    if (validationError) {
      const { title, description } = validationError;
      setOptionMessageView(
        totalAmount === '-'
          ? getOptionsMessages(title, description).unAvailable
          : getOptionsMessages(title, description).errorActivate
      );
    }
  }, [dataDiscount, isLoading]);

  const handlerActivateDiscount = () => {
    toggleBenefit(true);
  };

  // validate success activate for viewDetail
  useEffect(() => {
    if (
      optionMessageActivate &&
      JSON.stringify(Object.keys(optionMessageActivate)) ===
        JSON.stringify(Object.keys(getOptionsMessages().successActivate))
    ) {
      dispatch(pendingPaymentActions.getPendingPayments());
      dispatch(requestBenefitActions.getBenefitInstallments());
    }
  }, [optionMessageActivate]);

  const itemFullCycle = useMemo(() => {
    if (!dataPending || !dataBenefit) return null;
    return formatDiscountBenefitItems(
      dataPending?.pendingPayments,
      dataBenefit?.requestBenefit
    ).find((i: any) => i.isFullCycleDiscount);
  }, [dataPending, dataBenefit]);

  const isLoadingProgress = useMemo(
    () => isLoadingProgressActivate || isLoadingPending || isLoadingBenefit,
    [isLoadingProgressActivate, isLoadingPending, isLoadingBenefit]
  );

  return (
    <ContainerProcedure data-testid="full-cycle-discount-view">
      <SubContainer>
        <ContainerHeader>
          <Back onClick={handlerBack} dataTestid="button-back" />
          <Heading
            text="¡10% de descuento pagando el ciclo completo!"
            level={2}
            color="var(--text-text02)"
            size={24}
            lineHeight={32}
            fontWeight="700"
            align="flex-start"
          />
        </ContainerHeader>
        <SubContainerCenter>
          {RenderInfo({
            dataDiscount,
            isLoadingDataDiscount,
            handlerActivateDiscount,
            isDisabled
          })}
        </SubContainerCenter>
      </SubContainer>
      <ModalMessageFullCycle
        showModal={
          (showModalUnavailable || showModalActivate) && !isLoadingProgress
        }
        optionMessage={optionMessageView || optionMessageActivate}
        handlerBack={handlerBack}
        itemFullCycle={itemFullCycle}
      />
      <Processing isOpen={isLoadingProgress} />
    </ContainerProcedure>
  );
};

export default FullCycleDiscountView;
